// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { CrosshairIcon } from "src/assets/icons";

// Styles
import { ModalCustomConfirmLink } from "src/styles/mui/muiStylesHelper";

export type BaselineActionType = "add" | "update";

type ProgressionBaselineButtonType = {
  action: BaselineActionType;
  onClick: () => void;
  isHidden?: boolean;
  isExternal?: boolean;
};

// Opens the baseline picker from an exam row: "Add Baseline" while the analysis has none,
// "Update Baseline" on the rows that make up the current baseline pair.
const ProgressionBaselineButton = ({
  action,
  onClick,
  isHidden = false,
  isExternal = false,
}: ProgressionBaselineButtonType) => {
  const { t } = useTranslation();

  return (
    <Button
      startIcon={<CrosshairIcon />}
      aria-hidden={isHidden}
      tabIndex={isHidden ? -1 : undefined}
      sx={{
        visibility: isHidden ? "hidden" : "visible",
        ...ModalCustomConfirmLink(),
        width: "fit-content",
        height: "fit-content",
        whiteSpace: "nowrap",
        flexShrink: 0,
        textDecoration: "underline",
        ...(isExternal && {
          color: "#2563EB",
          "&:hover": {
            ...ModalCustomConfirmLink()["&:hover"],
            color: "#1D4ED8",
          },
        }),
      }}
      onClick={onClick}
    >
      <Typography
        sx={{ fontSize: "12px", fontWeight: 600, textTransform: "none" }}
      >
        {action === "add" ? t("Add Baseline") : t("Update Baseline")}
      </Typography>
    </Button>
  );
};

export default ProgressionBaselineButton;
